import { FunctionComponent } from 'react'
import styles from './LoggedOut.module.scss'
import CachedIcon from '@mui/icons-material/Cached'
import { removeServiceWorker } from '@/modules/utils/serviceWorker'

interface LoggedOutNavProps {
    hideRefresh?: boolean
}

const LoggedOutNav: FunctionComponent<LoggedOutNavProps> = ({ hideRefresh }: LoggedOutNavProps) => {
    return (
        <div className={styles.LoggedOutNav}>
            <div className={`${styles.LoggedOutNavCenter} ${hideRefresh && styles.CenterLoggedOut}`}>
                <a className={styles.LoggedOutNavLogo} onClick={removeServiceWorker}>
                    <img src='/images/logo_parent_iso.png' className={styles.LoggedOutNavParent} alt='Logo parent' />
                    <img src='/images/cald.svg' className={styles.LoggedOutNavCALD} alt='Logo Crèche À La Demande' />
                    <img src='/images/logo_daycare_iso.png' className={styles.LoggedOutNavDaycare} alt='Logo Crèche' />
                </a>
            </div>
            {!hideRefresh && (
                <div className={styles.LoggedOutNavRight}>
                    <a onClick={removeServiceWorker}>
                        <CachedIcon className={styles.RefreshIcon} />
                    </a>
                </div>
            )}
        </div>
    )
}
export default LoggedOutNav
